import { Container } from '@mui/material';
import { AppPage } from '@/shared/components';
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle';
import ClipDispatchConfig from '@/features/clip-dispatch/components/ClipDispatchConfig';
import PageHeader from '@/shared/components/PageHeader';

const ClipDispatchPage = () => {
  const title = 'Clip Dispatch';
  useDocumentTitle(title);

  return (
    <AppPage title={title} requiredPermissions={['menu:manage:dispatch']}>
      <Container maxWidth="xl" sx={{ marginTop: 4, marginBottom: 4 }}>
        <PageHeader title={title} subtitle="Configure webhooks, email notifications, and S3 copy destinations triggered when a clip export completes." />
        <ClipDispatchConfig />
      </Container>
    </AppPage>
  );
};

export default ClipDispatchPage;
